import axios from 'axios';
import { BASE_URL } from '../config/config';

// const URL = 'http://localhost:3000/reports';
const URL = BASE_URL + '/reports';

const getReportCOA = async (
  bulan,
  tahun,
  kodeCOA,
  kodeInt,
  kodeExt,
  kodePro,
  kodeBuNit
) => {
  try {
    const response = await axios.get(URL, {
      params: {
        bulan,
        tahun,
        kodeCOA,
        kodeInt,
        kodeExt,
        kodePro,
        kodeBuNit,
      },
    });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export { getReportCOA };
